import get from 'lodash/get';

/**
 * Determines if the passed user is in the beta group.
 *
 * @param {Object} user The user data object.
 *
 * @returns {boolean} True is user is in beta group.
 */
export const isUserBeta = (user) => {
	return !!get(user, 'inBeta') || !!get(user, 'beta.enabled');
};

/**
 * Determines if the passed user is in the AM Team group.
 *
 * @param {Object} user The user data object.
 *
 * @returns {boolean} True is user is in AM Team group.
 */
export const isUserAmTeam = (user) => {
	return !!get(user, 'isAmTeam');
};

/**
 * Determines if the passed user is a god-moded AM Team member.
 *
 * @since 0.1.8
 *
 * @param {Object} user The user data object.
 *
 * @returns {boolean} True is user is a god-moded AM Team member.
 */
export const isUserAmTeamGodMode = (user) => {
	return !!get(user, 'amgm');
};

/**
 * Determines if the passed user is in the OM Alpha group.
 *
 * @since 0.1.30
 *
 * @param {Object} user The user data object.
 *
 * @returns {boolean} True is user is in OM Alpha group.
 */
export const isUserOmAlpha = (user) => {
	return !!get(user, 'isOmAlpha');
};
